<template>
  <div>
    <div style="text-align: left">
      <div class="searchbarcls">
        角色名称:<el-input size="small" v-model="searchForm.roleName" style="width: 200px;"></el-input>
        &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadTableData()">查询</el-button>
      </div>
      <div style="padding: 2px;">
        <PermissionMethodToolbar :url="url" id="toolbar" @showAddDialog="showAddDialog"></PermissionMethodToolbar>
      </div>
    </div>
    <el-table ref="myElTable" background="true" :data="tableData" :height="clientHeight-otherHeight" @row-click="tableTrClick" border style="width: 100%;">
      <el-table-column type="selection" width="40" />
      <el-table-column type="index" label="序号" fixed="left" width="50" />
      <el-table-column prop="tenantName" label="企业名称" width="210" />
      <el-table-column prop="roleName" label="角色名称" width="210" />
      <el-table-column prop="roleRemark" label="备注信息" />
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <PermissionMethodRow :url="url" id="rowtoolbar" @showUpdateDialog="showUpdateDialog(scope.row)" @deleteRole="deleteRole(scope.row)"></PermissionMethodRow>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.currPage" :page-sizes="[20, 30, 40]" :page-size="20"
                   layout="total,jumper, prev, pager, next,sizes" :total="searchForm.dataTotal">
    </el-pagination>
    <!--添加div-->
    <el-drawer title="新增角色信息" size="53%" :visible.sync="drawer" :wrapperClosable="false" direction="rtl">
      <AddRoleWindow ref="addRoleWindow" :closeWindow="closeWindow"></AddRoleWindow>
    </el-drawer>
    <!--修改div-->
    <el-drawer title="修改角色信息" size="53%" :destroy-on-close="true" :visible.sync="updateDrawer" :wrapperClosable="false" direction="rtl">
      <UpdateRoleWindow ref="updateRoleWindow" :closeWindow="closeWindow" :rolePerData="rolePerData"></UpdateRoleWindow>
    </el-drawer>
  </div>
</template>
<script>
import { appjs } from "@/utiljs/apputil";
import AddRoleWindow from "./AddRoleWindow.vue";
import UpdateRoleWindow from "./UpdateRoleWindow.vue";
export default {
          components: {
            AddRoleWindow,
            UpdateRoleWindow
        },
  props: {
    clientHeight: {
      type: Number
    },
    url: {
      type: String
    }
  },
  data () {
    return {
      otherHeight: 210,
      drawer: false,
      updateDrawer: false,
      rolePerData: [],
      searchForm: {
        dataTotal: 0,
        pageSize: 20,
        currPage: 1,
        roleName: ''
      },
      tableData: []
    }
  },
  created () {
    this.loadTableData(1);
  },
  methods: {
    closeWindow (msg) {
      this.drawer = false;
      this.updateDrawer = false;
      if (msg) {
        this.loadTableData(1);
        appjs.showSuccessMsg(msg, 2000, 50);
      }
    },
    loadTableData () {
      let load = appjs.loading();
      let _self = this;
      let params = this.searchForm;
      appjs.httpRequest('role/queryAllRole', params).then(
        (data) => {
          if (data.retCode && data.retCode != "ok") {
            appjs.showErrorMsg(data.retMsg)
          } else {
            _self.searchForm.dataTotal = data.totalRowNum;
            _self.tableData = data.dataList;
            this.$refs.myElTable.bodyWrapper.scrollTop = 0;
          }
          appjs.unloading(load);
        }
      ).catch(
        (errmsg) => {
          appjs.showErrorMsg(errmsg)
          appjs.unloading(load);
        });
    },
    deleteRole (rowdata) {
      let _self = this;
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        let load = appjs.loading('数据删除中');
        appjs.httpRequest('role/deleteRole', { roleIds: rowdata.rolePid }).then(
          (data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.unloading(load);
              appjs.showErrorMsg(data.retMsg)
            } else {
              appjs.unloading(load);
              appjs.showSuccessMsg(data.retMsg)
              _self.loadTableData();
            }
          }
        ).catch(
          (errmsg) => {
            appjs.showErrorMsg(errmsg)
            appjs.unloading(load);
          });
      });
    },
    tableTrClick (row, column, event) {
      this.$refs.myElTable.clearSelection();
      this.$refs.myElTable.toggleRowSelection(row);
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val;
      this.loadTableData();
    },
    handleCurrentChange (val) {
      this.searchForm.currPage = val;
      this.loadTableData();
    },
    showAddDialog () {
      this.drawer = true;
      if (this.$refs['addRoleWindow']) {
        this.$refs['addRoleWindow'].resertForm();
      }
    },
    showUpdateDialog (rowdata) {
      let load = appjs.loading('数据加载中');
      let _self = this;
      appjs.httpRequest('role/queryRoleByPid', { rolePid: rowdata.rolePid }).then(
        (data) => {
          if (data.retCode && data.retCode != "ok") {
            appjs.unloading(load);
            appjs.showErrorMsg(data.retMsg)
          } else {
            _self.rolePerData = data;
            _self.updateDrawer = true;
            if (this.$refs['updateRoleWindow']) {
              this.$refs['updateRoleWindow'].resertForm(data);
            }
            appjs.unloading(load);
          }
        }
      ).catch(
        (errmsg) => {
          appjs.showErrorMsg(errmsg)
          appjs.unloading(load);
        });
    }
  }
}
</script>
